import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=0d541850&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=0d541850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d541850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d541850')) {
      api.createRecord('0d541850', component.options)
    } else {
      api.reload('0d541850', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=0d541850&scoped=true&", function () {
      api.rerender('0d541850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/weeklylogin/campaign/Edit.vue"
export default component.exports